export default "__VITE_ASSET__ZKXctj5j__"